import { restClient } from '@/Core'
import { userManager } from '@/Core/Managers'

import { NO_CACHE, NOTIFICATIONS_URL, UNREAD_FILTER } from '../Helpers/notificationApi'
import { NotificationStore } from '../Stores/NotificationStore'

import type { NotificationListResponse } from '../Helpers/notificationApi'

/** Скільки сповіщень за раз. */
const PAGE_SIZE = 30

/** Номер останнього запиту: відповідь на попередній (перемкнули вкладку) — уже не потрібна. */
let lastRequest = 0

/** Сторінка сповіщень за поточним фільтром шухляди. Перша — замінює список, наступні — дописують. */
export const LoadNotificationListTask = async (page = 1): Promise<void> => {
    if (!userManager.user?.['uuid']) return

    const request = ++lastRequest
    const filter = NotificationStore.filter

    NotificationStore.setLoading(page, true)

    try {
        const response = (await restClient.get(
            NOTIFICATIONS_URL,
            { searchParams: { page, limit: PAGE_SIZE, ...(filter === 'unread' ? { filters: UNREAD_FILTER } : {}) } },
            NO_CACHE
        )) as unknown as NotificationListResponse | null

        if (request !== lastRequest) return

        const total = response?.meta?.total ?? 0

        NotificationStore.setPage(response?.items ?? [], { page: response?.meta?.page ?? page, total })

        // Вкладка «Непрочитані» заразом каже правду про лічильник
        if (filter === 'unread') NotificationStore.setUnreadCount(total)
    } catch (error) {
        console.warn('LoadNotificationListTask error:', error)
    } finally {
        if (request === lastRequest) NotificationStore.setLoading(page, false)
    }
}
